import React from 'react';
import { TableCell, Box } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { ContactOverviewReportSortInput, EReportsSortDirection } from '__generated__/graphql';

interface SortableContactOverviewHeaderProps {
  field: keyof ContactOverviewReportSortInput;
  label: string;
  sortFields: ContactOverviewReportSortInput[];
  onSort: (field: keyof ContactOverviewReportSortInput, direction?: EReportsSortDirection) => void;
  align?: 'left' | 'center' | 'right';
}

export default function SortableContactOverviewHeader({
  field,
  label,
  sortFields,
  onSort,
  align = 'left',
}: SortableContactOverviewHeaderProps) {
  const isActive = sortFields.find((s) => s[field]) ? true : false;
  const direction = isActive ? sortFields.find((s) => s[field])?.[field] : null;

  return (
    <TableCell
      align={align}
      sx={{
        cursor: 'pointer',
        userSelect: 'none',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
      }}
      onClick={() => onSort(field)}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        {label}
        <Box sx={{ display: 'flex', flexDirection: 'column', ml: 0.5 }}>
          <ArrowUpwardIcon
            fontSize="small"
            sx={{
              fontSize: '0.875rem',
              opacity: direction === 'asc' ? 1 : 0.3,
              color: direction === 'asc' ? 'primary.main' : 'text.secondary',
            }}
          />
          <ArrowDownwardIcon
            fontSize="small"
            sx={{
              fontSize: '0.875rem',
              marginTop: '-4px',
              opacity: direction === 'desc' ? 1 : 0.3,
              color: direction === 'desc' ? 'primary.main' : 'text.secondary',
            }}
          />
        </Box>
      </Box>
    </TableCell>
  );
}